// Asset status vocabulary.
//
// Background: the backend was renamed from legacy "Available" → new "Active"
// (see backend/routes/assets.py:797/1013/1344 comments and the bilingual
// backend stat query at line 1353). Any asset created via POST /api/assets
// after that migration gets status="Active"; older rows and any row edited
// via the dropdown still say "Available". Both mean the same thing —
// "ready to check out."
//
// This helper keeps the frontend bilingual so the render conditions match
// whichever spelling the DB happens to hold, and the count reconciles.
export const AVAILABLE_STATUSES = new Set(['Active', 'Available']);

export function isAvailable(asset) {
  return AVAILABLE_STATUSES.has(asset?.status);
}

// Feb 2026 round 7 — Check-Out/Check-In eligibility. Two levels:
// 1) Category-level `field_use=false` (Shop Tools, Forklift, Skid Steer)
//    hides every asset in that category — set on equipmentCategories.
// 2) Asset-level `field_use=false` hides one specific asset even when its
//    category otherwise allows check-out (personal trucks TV2-TV11 living
//    inside the same "Trucks and Vehicles" category as Flex Vehicles).
// Both default to true (`!== false`) so legacy rows keep showing until
// someone actively opts them out.
export function isFieldUsable(asset, equipmentCategories) {
  if (asset?.field_use === false) return false;
  const cat = (equipmentCategories || []).find(
    (c) => (c?.name || '').toLowerCase() === (asset?.category || '').toLowerCase()
  );
  if (cat && cat.field_use === false) return false;
  return true;
}

// Lightweight preview of the future "Overdue Checkout Alerts" feature —
// how many whole days an asset has been checked out, for a quick-glance
// badge on the Equipment list. Returns null when not checked out or the
// timestamp is missing (older rows predating checked_out_at).
export function daysCheckedOut(asset) {
  if (asset?.status !== 'Checked Out' || !asset?.checked_out_at) return null;
  const since = new Date(asset.checked_out_at);
  if (isNaN(since.getTime())) return null;
  const now = new Date();
  return Math.max(0, Math.floor((now - since) / 86400000));
}
